export default "__VITE_ASSET__Bz80obgT__"